import { useLayoutEffect, useRef } from "react";

/** iter408 pt 2 — haut de page fixe au défilement : tout ce qui est au-dessus de la liste (en-tête, onglets, KPI,
 *  filtres, recherche) reste collé en haut ; seule la liste défile (barre de défilement de la fenêtre, unique).
 *  Fond opaque identique au fond actuel (classe `wallpaper`), aucune ombre. La hauteur mesurée est publiée dans
 *  `--desk-sticky-h` pour coller les titres de colonnes (`data-sticky-head`) juste sous la partie fixe. */
export default function StickyTop({ children, gap = 14, testId = "sticky-top" }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const root = document.documentElement;
    const content = el.closest(".app-content");
    const pt = content ? parseFloat(getComputedStyle(content).paddingTop) || 0 : 0;
    el.style.marginTop = `-${pt}px`;
    el.style.paddingTop = `${pt}px`;
    const publish = () => root.style.setProperty("--desk-sticky-h", `${Math.round(el.getBoundingClientRect().height)}px`);
    publish();
    const ro = new ResizeObserver(publish);
    ro.observe(el);
    return () => { ro.disconnect(); root.style.setProperty("--desk-sticky-h", "0px"); };
  }, []);
  return (
    <div ref={ref} className="wallpaper desk-sticky-top" style={{ position: "sticky", top: 0, zIndex: 30, paddingBottom: gap }} data-testid={testId}>
      {children}
    </div>
  );
}
